import { gsap, CustomEase } from '../../global/gsap';

const initThinking = (section) => {
    const cards = section.querySelectorAll('.js-thinking-card');

    if (cards) {
        cards.forEach((card, i) => {
            // Skip first card
            if (i !== 0) {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: card,
                        start: 'top bottom',
                        end: 'top 35%',
                        scrub: 1.1,
                        invalidateOnRefresh: true
                    }
                });

                gsap.set(card, {
                    scale: 0.8
                });

                tl.to(card, {
                    scale: 1,
                    ease: CustomEase.create('custom', '0.22, 1, 0.36, 1')
                });
            }
        });
    }
};

export default initThinking;
